import { ExamGradeLabel, HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '../../models';
import { LocDisplayType } from '../../models/display-type';
import { SYSTEM_ENUM_ROOT, SYSTEM_ENUM_TYPE } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|Exam Grade Label`;

const sharedLocData: Pick<LocDef, 'displayType' | 'htmlAllowed' | 'shared' | 'feature'> = {
	displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
	htmlAllowed: false,
	shared: false,
	feature: HubFeature.Exam,
};

export type CPExamGradeLabelLocs =
	| 'CPExamGradeLabelEnumFail'
	| 'CPExamGradeLabelEnumPass'
	| 'CPExamGradeLabelEnumUngraded';

export type SPExamGradeLabelLocs =
	| 'SPExamGradeLabelEnumFail'
	| 'SPExamGradeLabelEnumPass'
	| 'SPExamGradeLabelEnumUngraded';

export const cpExamGradeLabelEnumLocs: LocDefs<CPExamGradeLabelLocs> = {
	CPExamGradeLabelEnumFail: {
		defaultValue: 'Fail',
		displayPath: `${dpRoot}|${ExamGradeLabel.Fail}`,
		description: `System value for '${ExamGradeLabel.Fail}' exam grade label`,
		legacyName: 'Exam/System.Enum.ExamGradeLabel.Fail',
		portal: 'CP',
		...sharedLocData,
	},
	CPExamGradeLabelEnumPass: {
		defaultValue: 'Pass',
		displayPath: `${dpRoot}|${ExamGradeLabel.Pass}`,
		description: `System value for '${ExamGradeLabel.Pass}' exam grade label`,
		legacyName: 'Exam/System.Enum.ExamGradeLabel.Pass',
		portal: 'CP',
		...sharedLocData,
	},
	CPExamGradeLabelEnumUngraded: {
		defaultValue: 'Ungraded',
		displayPath: `${dpRoot}|${ExamGradeLabel.Ungraded}`,
		description: `System value for '${ExamGradeLabel.Ungraded}' exam grade label`,
		legacyName: 'Exam/System.Enum.ExamGradeLabel.Ungraded',
		portal: 'CP',
		...sharedLocData,
	},
};

export const spExamGradeLabelEnumLocs: LocDefs<SPExamGradeLabelLocs> = {
	SPExamGradeLabelEnumFail: {
		defaultValue: 'Fail',
		displayPath: `${dpRoot}|${ExamGradeLabel.Fail}`,
		description: `System value for '${ExamGradeLabel.Fail}' exam grade label`,
		legacyName: 'Exam/System.Enum.ExamGradeLabel.Fail',
		portal: 'SP',
		...sharedLocData,
	},
	SPExamGradeLabelEnumPass: {
		defaultValue: 'Pass',
		displayPath: `${dpRoot}|${ExamGradeLabel.Pass}`,
		description: `System value for '${ExamGradeLabel.Pass}' exam grade label`,
		legacyName: 'Exam/System.Enum.ExamGradeLabel.Pass',
		portal: 'SP',
		...sharedLocData,
	},
	SPExamGradeLabelEnumUngraded: {
		defaultValue: 'Ungraded',
		displayPath: `${dpRoot}|${ExamGradeLabel.Ungraded}`,
		description: `System value for '${ExamGradeLabel.Ungraded}' exam grade label`,
		legacyName: 'Exam/System.Enum.ExamGradeLabel.Ungraded',
		portal: 'SP',
		...sharedLocData,
	},
};

export const EXAM_GRADE_LABEL_ENUM_LOCS = MapLocKeys<CPExamGradeLabelLocs | SPExamGradeLabelLocs>({
	...cpExamGradeLabelEnumLocs,
	...spExamGradeLabelEnumLocs,
});

export type CPExamGradeLabelEnumLocType = LocMap<CPExamGradeLabelLocs>;
export type SPExamGradeLabelEnumLocType = LocMap<SPExamGradeLabelLocs>;

export const cpExamGradeLabelKeys: { [key in ExamGradeLabel]: keyof CPExamGradeLabelEnumLocType } =
	{
		Pass: EXAM_GRADE_LABEL_ENUM_LOCS.CPExamGradeLabelEnumPass,
		Fail: EXAM_GRADE_LABEL_ENUM_LOCS.CPExamGradeLabelEnumFail,
		Ungraded: EXAM_GRADE_LABEL_ENUM_LOCS.CPExamGradeLabelEnumUngraded,
	};

export const spExamGradeLabelKeys: { [key in ExamGradeLabel]: keyof SPExamGradeLabelEnumLocType } =
	{
		Pass: EXAM_GRADE_LABEL_ENUM_LOCS.SPExamGradeLabelEnumPass,
		Fail: EXAM_GRADE_LABEL_ENUM_LOCS.SPExamGradeLabelEnumFail,
		Ungraded: EXAM_GRADE_LABEL_ENUM_LOCS.SPExamGradeLabelEnumUngraded,
	};
